import { formatTimeFromNow } from "@/lib/mockData";

const ChatBubble = ({ message }) => {
  if (message.me) {
    return (
      <div className="flex justify-end mb-2" data-testid={`msg-${message.id}`}>
        <div className="max-w-[78%]">
          <div className="bg-[#0A0A0A] text-white rounded-2xl rounded-br-md px-4 py-2.5">
            <p className="text-sm">{message.text}</p>
          </div>
          <div className="text-[10px] text-[#999] mt-1 text-right font-mono">{formatTimeFromNow(message.iso)}</div>
        </div>
      </div>
    );
  }
  return (
    <div className="flex gap-2 mb-2" data-testid={`msg-${message.id}`}>
      <img src={message.sender.avatar} alt={message.sender.name} className="w-7 h-7 rounded-full brutal-border object-cover mt-1" />
      <div className="max-w-[78%]">
        <div className="text-[10px] font-bold text-[#555555] mb-0.5 ml-1">{message.sender.name}</div>
        <div className="bg-white brutal-border rounded-2xl rounded-bl-md px-4 py-2.5">
          <p className="text-sm">{message.text}</p>
        </div>
        <div className="text-[10px] text-[#999] mt-1 ml-1 font-mono">{formatTimeFromNow(message.iso)}</div>
      </div>
    </div>
  );
};

export default ChatBubble;
